module.exports = __webpack_public_path__ + "static/media/Manju.9a555105.jpg";